/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA received-reviews React view (inbox)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsReceivedRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.received',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsReceivedRoute);
